module.exports = __webpack_public_path__ + "img/Group 6534.264dc554.png";